(function () {
  function scrollAmount(track) {
    var tile = track.querySelector('.tcm-tile');
    if (!tile) return track.clientWidth * 0.75;

    var styles = window.getComputedStyle(track);
    var gap = parseFloat(styles.columnGap || styles.gap || 0) || 10;
    return tile.getBoundingClientRect().width + gap;
  }

  function updateNavState(root) {
    var track = root.querySelector('[data-tcm-track]');
    var nextBtn = root.querySelector('[data-tcm-next]');
    if (!track || !nextBtn) return;

    var maxScroll = track.scrollWidth - track.clientWidth;
    nextBtn.disabled = track.scrollLeft >= maxScroll - 4;
  }

  function initTrendingCategories() {
    document.querySelectorAll('[data-trending-categories]').forEach(function (root) {
      if (root.dataset.tcmReady === 'true') return;

      var track = root.querySelector('[data-tcm-track]');
      var nextBtn = root.querySelector('[data-tcm-next]');
      if (!track) return;

      if (nextBtn) {
        nextBtn.addEventListener('click', function () {
          track.scrollBy({ left: scrollAmount(track), behavior: 'smooth' });
        });
      }

      track.addEventListener('scroll', function () {
        updateNavState(root);
      });

      window.addEventListener('resize', function () {
        updateNavState(root);
      });

      updateNavState(root);
      root.dataset.tcmReady = 'true';
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initTrendingCategories);
  } else {
    initTrendingCategories();
  }

  document.addEventListener('shopify:section:load', initTrendingCategories);
})();
